import * as types from "../constants/ActionTypes";
import { cloneDeep } from "lodash";

// Converte qualquer valor para string, replicando o que a concatenação antiga
// produzia (ex.: undefined -> "undefined"), para não mudar o comportamento.
const toStr = (value) => String(value);

// A mensagem chega "escapada": as aspas vêm precedidas de barras invertidas
// (multiplicadas pelas camadas de transporte) e barras "literais" chegam
// repetidas. Esta função remove esses artefatos de forma segura.
const decodeMessage = (action) => {
  let s = action.message == null ? "" : String(action.message);

  // Barras que antecedem aspas (simples ou duplas) são só escaping: remove-as,
  // deixando apenas a aspa.  Ex.: \\\\'Teste\\\\' -> 'Teste'
  s = s.replace(/\\+(['"])/g, "$1");

  // Colapsa qualquer sequência de barras invertidas restante para uma só.
  // Ex.: "Teste \\\\" -> "Teste \"
  s = s.replace(/\\+/g, "\\");

  return s;
};

// Monta o objeto de mensagem diretamente, sem montar/parsear JSON por string.
const buildMessageObject = (action) => ({
  typemsg: toStr(action.typemsg),
  contactid: action.contactid,
  datatime: toStr(action.datatime),
  author: toStr(action.author),
  message: decodeMessage(action),
  messageid: toStr(action.messageid),
  statusmsg: toStr(action.statusmsg),
  star: toStr(action.favorite),
  favorite: toStr(action.favorite),
  dia: toStr(action.dia),
  username: toStr(action.username),
  monuser: toStr(action.monuser),
  destiny: toStr(action.destiny),
  typemon: toStr(action.typemon),
  replyid: toStr(action.replyid),
  options: toStr(action.options),
  titlemsg: (action.title || "").replace(/[\r\n]+/g, "\\n").trim(),
  anoenvio: toStr(action.anoenvio),
  dataenvio: toStr(action.dataenvio),
});

const formatMessages = (action) => buildMessageObject(action);

const formatMessagesOld = (action) => {
  try {
    let titlemsg = (action.title || "").replace(/[\r\n]+/g, "\\n").trim();

    let safeMessage = action.message;
    if (
      (action.typemsg === "0" || action.typemsg === 0) &&
      action.author === "Me"
    ) {
      safeMessage = (action.message || "").replace(/\\/g, "\\\\");
    }

    if (
      (action.typemsg === "0" || action.typemsg === 0) &&
      action.author !== "Me"
    ) {
      safeMessage = (action.message || "").replace(/\\\\/g, "\\");
    }
    let text =
      '{"' +
      action.contactid +
      '": [{"typemsg":"' +
      action.typemsg +
      '","contactid":"' +
      action.contactid +
      '","datatime":"' +
      action.datatime +
      '","author":"' +
      action.author +
      '","message":"' +
      safeMessage +
      '", "messageid":"' +
      action.messageid +
      '","statusmsg":"' +
      action.statusmsg +
      '","star":"' +
      action.favorite +
      '","favorite":"' +
      action.favorite +
      '","dia":"' +
      action.dia +
      '","username":"' +
      action.username +
      '","monuser":"' +
      action.monuser +
      '","destiny":"' +
      action.destiny +
      '","typemon":"' +
      action.typemon +
      '","replyid":"' +
      action.replyid +
      '","options":"' +
      action.options +
      '","titlemsg":"' +
      titlemsg +
      '","anoenvio":"' +
      action.anoenvio +
      '","dataenvio":"' +
      action.dataenvio +
      '"}]}';
    var obj = JSON.parse(text);
  } catch (e) {
    let message_f = action.message;
    console.log("ERROJSON_1 : ", action.title);
    let message_fd = message_f.replace(/^[a-záàâãéèêíïóôõöúçñ ]+$/i);
    message_fd = message_fd.replace(/\n|\r\n/gi, "¿");
    message_fd = message_fd.replace(/"/gi, "'").trim();
    let titlemsg = (action.title || "").replace(/[\r\n]+/g, "\\n").trim();
    // message_fd = message_fd.replace(/[^a-zA-Z 0-9]/g, '')
    console.log("ERROJSON_2 : ", titlemsg);
    let text =
      '{"' +
      action.contactid +
      '": [{"typemsg":"' +
      action.typemsg +
      '","contactid":"' +
      action.contactid +
      '","datatime":"' +
      action.datatime +
      '","author":"' +
      action.author +
      '","message":"' +
      message_fd +
      '", "messageid":"' +
      action.messageid +
      '", "statusmsg":"' +
      action.statusmsg +
      '", "star":"' +
      action.favorite +
      '","favorite":"' +
      action.favorite +
      '","dia":"' +
      action.dia +
      '","username":"' +
      action.username +
      '","monuser":"' +
      action.monuser +
      '","destiny":"' +
      action.destiny +
      '","typemon":"' +
      action.typemon +
      '","replyid":"' +
      action.replyid +
      '","options":"' +
      action.options +
      '","titlemsg":"' +
      titlemsg +
      '","anoenvio":"' +
      action.anoenvio +
      '","dataenvio":"' +
      action.dataenvio +
      '"}]}';

    console.log("ERROJSON_DEPOIS : ", text);

    try {
      var obj = JSON.parse(text);
    } catch (error) {
      let text =
        '{"' +
        action.contactid +
        '": [{"typemsg":"' +
        action.typemsg +
        '","contactid":"' +
        action.contactid +
        '","datatime":"' +
        action.datatime +
        '","author":"' +
        action.author +
        '","message":"' +
        "" +
        '", "messageid":"' +
        action.messageid +
        '", "statusmsg":"' +
        action.statusmsg +
        '", "star":"' +
        action.favorite +
        '","favorite":"' +
        action.favorite +
        '","dia":"' +
        action.dia +
        '","username":"' +
        action.username +
        '","monuser":"' +
        action.monuser +
        '","destiny":"' +
        action.destiny +
        '","typemon":"' +
        action.typemon +
        '","replyid":"' +
        action.replyid +
        '","options":"' +
        action.options +
        '","titlemsg":"' +
        titlemsg +
        '","anoenvio":"' +
        action.anoenvio +
        '","dataenvio":"' +
        action.dataenvio +
        '"}]}';
      var obj = JSON.parse(text);
    }
  }

  let key = Object.keys(obj)[0];
  return obj[key][0];
};

const messages = (state = [], action) => {
  switch (action.type) {
    case types.ADD_MESSAGES_IN_BATCH_REVERSE_MODE:
      const clonedMessagesToAddInReverseMode = { ...state };
      const previousMessagesToAddInReverseMode = [];
      action.messages.forEach((message) => {
        const messageToAdd =
          message.typemsg === "0" || message.typemsg === 0
            ? formatMessages(message)
            : formatMessagesOld(message);
        previousMessagesToAddInReverseMode.push(messageToAdd);
      });
      if (action.cdr in clonedMessagesToAddInReverseMode) {
        clonedMessagesToAddInReverseMode[action.cdr] = [
          ...previousMessagesToAddInReverseMode,
          ...clonedMessagesToAddInReverseMode[action.cdr],
        ];
      } else {
        clonedMessagesToAddInReverseMode[action.cdr] =
          previousMessagesToAddInReverseMode;
      }

      return clonedMessagesToAddInReverseMode;
    case types.ADD_MESSAGES_IN_BATCH:
      const clonedMessages = { ...state };
      action.messages.forEach((message) => {
        const messageToAdd =
          message.typemsg === "0" || message.typemsg === 0
            ? formatMessages(message)
            : formatMessagesOld(message);
        if (action.cdr in clonedMessages) {
          clonedMessages[action.cdr] = [
            ...clonedMessages[action.cdr],
            messageToAdd,
          ];
        } else {
          clonedMessages[action.cdr] = [messageToAdd];
        }
      });
      return clonedMessages;
    case types.CLEAR_MESSAGE_ALL:
      console.log("INGENIUM_INITIALLOGIN");
      return [];
    case types.ADD_MESSAGE:
    case types.MESSAGE_RECEIVED:
      if (action.typemsg === "0" || action.typemsg === 0) {
        var messageObj = buildMessageObject(action);
        var newState = cloneDeep(state);

        try {
          if (
            action.contactid in newState &&
            Array.isArray(newState[action.contactid])
          ) {
            newState[action.contactid].push(messageObj);
          } else {
            newState[action.contactid] = [messageObj];
          }
          return newState;
        } catch (error) {
          console.log("INGENIUM_ERROR_MESSAGES : ", error);
          return newState;
        }
      } else {
        try {
          let titlemsg = (action.title || "").replace(/[\r\n]+/g, "\\n").trim();
          let safeMessage = action.message;
          if (
            (action.typemsg === "0" || action.typemsg === 0) &&
            action.author === "Me"
          ) {
            safeMessage = (action.message || "").replace(/\\/g, "\\\\");
          }

          if (
            (action.typemsg === "0" || action.typemsg === 0) &&
            action.author !== "Me"
          ) {
            safeMessage = (action.message || "").replace(/\\\\/g, "\\");
          }

          let text =
            '{"' +
            action.contactid +
            '": [{"typemsg":"' +
            action.typemsg +
            '","contactid":"' +
            action.contactid +
            '","datatime":"' +
            action.datatime +
            '","author":"' +
            action.author +
            '","message":"' +
            safeMessage +
            '", "messageid":"' +
            action.messageid +
            '","statusmsg":"' +
            action.statusmsg +
            '","star":"' +
            action.favorite +
            '","favorite":"' +
            action.favorite +
            '","dia":"' +
            action.dia +
            '","username":"' +
            action.username +
            '","monuser":"' +
            action.monuser +
            '","destiny":"' +
            action.destiny +
            '","typemon":"' +
            action.typemon +
            '","replyid":"' +
            action.replyid +
            '","options":"' +
            action.options +
            '","titlemsg":"' +
            titlemsg +
            '","anoenvio":"' +
            action.anoenvio +
            '","dataenvio":"' +
            action.dataenvio +
            '"}]}';
          var obj = JSON.parse(text);
        } catch (e) {
          let message_f = action.message;
          console.log("ERROJSON_1 : ", action.title);
          let message_fd = message_f.replace(/^[a-záàâãéèêíïóôõöúçñ ]+$/i);
          message_fd = message_fd.replace(/\n|\r\n/gi, "¿");
          message_fd = message_fd.replace(/"/gi, "'").trim();
          let titlemsg = (action.title || "").replace(/[\r\n]+/g, "\\n").trim();
          // message_fd = message_fd.replace(/[^a-zA-Z 0-9]/g, '')
          console.log("ERROJSON_2 : ", titlemsg);
          let text =
            '{"' +
            action.contactid +
            '": [{"typemsg":"' +
            action.typemsg +
            '","contactid":"' +
            action.contactid +
            '","datatime":"' +
            action.datatime +
            '","author":"' +
            action.author +
            '","message":"' +
            message_fd +
            '", "messageid":"' +
            action.messageid +
            '", "statusmsg":"' +
            action.statusmsg +
            '", "star":"' +
            action.favorite +
            '","favorite":"' +
            action.favorite +
            '","dia":"' +
            action.dia +
            '","username":"' +
            action.username +
            '","monuser":"' +
            action.monuser +
            '","destiny":"' +
            action.destiny +
            '","typemon":"' +
            action.typemon +
            '","replyid":"' +
            action.replyid +
            '","options":"' +
            action.options +
            '","titlemsg":"' +
            titlemsg +
            '","anoenvio":"' +
            action.anoenvio +
            '","dataenvio":"' +
            action.dataenvio +
            '"}]}';

          console.log("ERROJSON_DEPOIS : ", text);

          try {
            var obj = JSON.parse(text);
          } catch (error) {
            let text =
              '{"' +
              action.contactid +
              '": [{"typemsg":"' +
              action.typemsg +
              '","contactid":"' +
              action.contactid +
              '","datatime":"' +
              action.datatime +
              '","author":"' +
              action.author +
              '","message":"' +
              "" +
              '", "messageid":"' +
              action.messageid +
              '", "statusmsg":"' +
              action.statusmsg +
              '", "star":"' +
              action.favorite +
              '","favorite":"' +
              action.favorite +
              '","dia":"' +
              action.dia +
              '","username":"' +
              action.username +
              '","monuser":"' +
              action.monuser +
              '","destiny":"' +
              action.destiny +
              '","typemon":"' +
              action.typemon +
              '","replyid":"' +
              action.replyid +
              '","options":"' +
              action.options +
              '","titlemsg":"' +
              titlemsg +
              '","anoenvio":"' +
              action.anoenvio +
              '","dataenvio":"' +
              action.dataenvio +
              '"}]}';
            var obj = JSON.parse(text);
          }
        }

        var newState = cloneDeep(state);

        try {
          if (
            Object.keys(obj)[0] in newState &&
            Array.isArray(newState[Object.keys(obj)[0]])
          ) {
            let key = Object.keys(obj)[0];
            newState[key].push(obj[key][0]);
            return newState;
          } else {
            let key = Object.keys(obj)[0];
            newState[key] = [obj[key][0]];
            return newState;
          }
        } catch (error) {
          console.log("INGENIUM_ERROR_MESSAGES : ", error);
          return newState;
        }
      }

    case types.CLEAR_MESSAGE:
      delete state[action.id];
      return state;
    case types.CLEAR_MESSAGE_MON:
      delete state[action.monuser];
      return state;
    case types.EDIT_MESSAGEID:
      var newState = { ...state };
      var cdrid = parseInt(action.cdrid);
      var NovaMensagem = newState[cdrid];
      if (NovaMensagem) {
        for (var i = 0; i < NovaMensagem.length; i++) {
          var obj = NovaMensagem[i];
          if (obj.messageid === action.callid) {
            obj.messageid = action.msgid;
            obj.statusmsg = action.status;
            obj.titlemsg = action.title;
            break;
          }
        }
        var newState = { ...state };
        return newState;
      }
    case types.EDIT_STATUSMSG:
      var newState = { ...state };
      var cdrid = parseInt(action.cdrid);
      var NovaMensagem = newState[cdrid];
      if (NovaMensagem) {
        for (var i = 0; i < NovaMensagem.length; i++) {
          var obj = NovaMensagem[i];
          if (parseInt(obj.messageid) === parseInt(action.msgid)) {
            obj.statusmsg = action.status;
            obj.titlemsg = action.title;
            break;
          }
        }
        var newState = { ...state };
        return newState;
      }
    case types.EDIT_MARKSTAR:
      var newState = { ...state };
      var cdrid = parseInt(action.cdrid);
      var NovaMensagem = newState[cdrid];
      if (NovaMensagem) {
        for (var i = 0; i < NovaMensagem.length; i++) {
          var obj = NovaMensagem[i];
          if (obj.messageid === action.msgid) {
            //obj.star = action.favorite;
            obj.favorite = action.favorite;
            break;
          }
        }
        var newState = { ...state };
        return newState;
      }

    case types.DELETE_MESSAGE:
      var newState = { ...state };
      var cdrid = parseInt(action.cdrid);
      var NovaMensagem = newState[cdrid];

      if (NovaMensagem) {
        let indexdeleted = null;
        for (var i = 0; i < NovaMensagem.length; i++) {
          var obj = NovaMensagem[i];
          if (parseInt(obj.messageid) === parseInt(action.msgid)) {
            indexdeleted = i;
            break;
          }
        }
        NovaMensagem.splice(indexdeleted, 1);
        var newState = { ...state };
        return newState;
      }
    default:
      return state;
  }
};

export default messages;

// import * as types from "../constants/ActionTypes";

// const messages = (state = [], action) => {
//   switch (action.type) {
//     case types.ADD_MESSAGE:
//     case types.MESSAGE_RECEIVED:
//       try {
//         let titlemsg = (action.title || "").replace(/[\r\n]+/g, "\\n").trim();

//         let text =
//           '{"' +
//           action.contactid +
//           '": [{"typemsg":"' +
//           action.typemsg +
//           '","contactid":"' +
//           action.contactid +
//           '","datatime":"' +
//           action.datatime +
//           '","author":"' +
//           action.author +
//           '","message":"' +
//           action.message +
//           '", "messageid":"' +
//           action.messageid +
//           '","statusmsg":"' +
//           action.statusmsg +
//           '","star":"' +
//           action.favorite +
//           '","favorite":"' +
//           action.favorite +
//           '","dia":"' +
//           action.dia +
//           '","username":"' +
//           action.username +
//           '","monuser":"' +
//           action.monuser +
//           '","destiny":"' +
//           action.destiny +
//           '","typemon":"' +
//           action.typemon +
//           '","replyid":"' +
//           action.replyid +
//           '","options":"' +
//           action.options +
//           '","titlemsg":"' +
//           titlemsg +
//           '","anoenvio":"' +
//           action.anoenvio +
//           '","dataenvio":"' +
//           action.dataenvio +
//           '"}]}';
//         var obj = JSON.parse(text);
//       } catch (e) {
//         let message_f = action.message;
//         console.log("ERROJSON_1 : ",action.title)
//         let message_fd = message_f.replace(/^[a-záàâãéèêíïóôõöúçñ ]+$/i);
//         message_fd = message_fd.replace(/\n|\r\n/gi, "¿");
//         message_fd = message_fd.replace(/"/gi, "'").trim();
//         let titlemsg = (action.title || "").replace(/[\r\n]+/g, "\\n").trim();
//         // message_fd = message_fd.replace(/[^a-zA-Z 0-9]/g, '')
//         console.log("ERROJSON_2 : ",titlemsg)
//         let text =
//           '{"' +
//           action.contactid +
//           '": [{"typemsg":"' +
//           action.typemsg +
//           '","contactid":"' +
//           action.contactid +
//           '","datatime":"' +
//           action.datatime +
//           '","author":"' +
//           action.author +
//           '","message":"' +
//           message_fd +
//           '", "messageid":"' +
//           action.messageid +
//           '", "statusmsg":"' +
//           action.statusmsg +
//           '", "star":"' +
//           action.favorite +
//           '","favorite":"' +
//           action.favorite +
//           '","dia":"' +
//           action.dia +
//           '","username":"' +
//           action.username +
//           '","monuser":"' +
//           action.monuser +
//           '","destiny":"' +
//           action.destiny +
//           '","typemon":"' +
//           action.typemon +
//           '","replyid":"' +
//           action.replyid +
//           '","options":"' +
//           action.options +
//           '","titlemsg":"' +
//           titlemsg  +
//           '","anoenvio":"' +
//           action.anoenvio +
//           '","dataenvio":"' +
//           action.dataenvio +
//           '"}]}';

//       console.log("ERROJSON_DEPOIS : ",text)

//         var obj = JSON.parse(text);
//       }

//       var newState = { ...state };

//       if (Object.keys(obj)[0] in newState) {
//         let key = Object.keys(obj)[0];
//         newState[key].push(obj[key][0]);
//         return newState;
//       } else {
//         let key = Object.keys(obj)[0];
//         newState[key] = [obj[key][0]];
//         return newState;
//       }

//     case types.CLEAR_MESSAGE:
//       delete state[action.id];
//       return state;
//     case types.CLEAR_MESSAGE_MON:
//       delete state[action.monuser];
//       return state;
//     case types.EDIT_MESSAGEID:
//       var newState = { ...state };
//       var cdrid = parseInt(action.cdrid);
//       var NovaMensagem = newState[cdrid];
//       if (NovaMensagem) {
//         for (var i = 0; i < NovaMensagem.length; i++) {
//           var obj = NovaMensagem[i];
//           if (obj.messageid === action.callid) {
//             obj.messageid = action.msgid;
//             obj.statusmsg = action.status;
//             obj.titlemsg = action.title;
//             break;
//           }
//         }
//         var newState = { ...state };
//         return newState;
//       }
//     case types.EDIT_STATUSMSG:
//       var newState = { ...state };
//       var cdrid = parseInt(action.cdrid);
//       var NovaMensagem = newState[cdrid];
//       if (NovaMensagem) {
//         for (var i = 0; i < NovaMensagem.length; i++) {
//           var obj = NovaMensagem[i];
//           if (parseInt(obj.messageid) === parseInt(action.msgid)) {
//             obj.statusmsg = action.status;
//             obj.titlemsg = action.title;
//             break;
//           }
//         }
//         var newState = { ...state };
//         return newState;
//       }
//     case types.EDIT_MARKSTAR:
//       var newState = { ...state };
//       var cdrid = parseInt(action.cdrid);
//       var NovaMensagem = newState[cdrid];
//       if (NovaMensagem) {
//         for (var i = 0; i < NovaMensagem.length; i++) {
//           var obj = NovaMensagem[i];
//           if (obj.messageid === action.msgid) {
//             //obj.star = action.favorite;
//             obj.favorite = action.favorite;
//             break;
//           }
//         }
//         var newState = { ...state };
//         return newState;
//       }

//       case types.DELETE_MESSAGE:
//         var newState = { ...state };
//         var cdrid = parseInt(action.cdrid);
//         var NovaMensagem = newState[cdrid];

//         if (NovaMensagem) {
//           let indexdeleted = null;
//             for (var i = 0; i < NovaMensagem.length; i++) {
//               var obj = NovaMensagem[i];
//               if (parseInt(obj.messageid) === parseInt(action.msgid)) {
//                 indexdeleted = i;
//                 break;
//               }
//             }
//             NovaMensagem.splice(indexdeleted,1);
//             var newState = { ...state };
//             return newState;

//         }
//     default:
//       return state;
//   }
// };

// export default messages;
